/**
 * Once we remove all of the bim360 components, we can get rid of this.
 * Until then, we need to include the LocaleProvider.
 *
 * Snippet taken from:
 * https://git.autodesk.com/BIM360/quantification-ui-web/blob/a76f344201b7914f2de0461e85e0ccd8db4a9a7c/src/utils/Utils.ts
 */
export const getBrowserLocale = () => {
  const locale =
    (navigator.languages && navigator.languages[0]) || // Chrome / Firefox
    navigator.language; // All browsers, but for Chrome it's the app's language
  if (locale === "zh-CN") {
    return "zh-Hans";
  }
  if (locale === "zh-HK") {
    return "zh-Hant-HK";
  }
  if (locale === "zh-TW") {
    return "zh-Hant";
  }
  if (locale === "en-US") {
    return "en";
  }
  if (locale === "es-MX") {
    return "es";
  }
  return locale;
};
